import { Alert, Typography } from 'antd'
import QuestionnaireSystemForm from 'components/Main/QuestionnaireSystem/QuestionnaireSystemForm'
import RatingSystemForm from 'components/Main/RatingSystem/RatingSystemForm'
import FormSectionTitle from 'elements/FormSectionTitle'
import React from 'react'
import CustomSpin from '../../../../elements/CustomSpin'

const { Paragraph } = Typography

function AddQuestionnaireSystem(props) {
  const { fetching, formRef, template, data, isNew } = props

  return (
    <CustomSpin spinning={fetching}>
      <FormSectionTitle title={template.name} />
      {template.description && (
        <div className="mb-5">
          <Paragraph>{template.description}</Paragraph>
        </div>
      )}
      {isNew && (
        <div className="px-20 py-5">
          <Alert
            message="Performance Survey"
            description="Please select the appropriate rating to the questions below relating to this particular order"
            type="info"
          />
        </div>
      )}
      <QuestionnaireSystemForm ref={formRef} {...props} />
    </CustomSpin>
  )
}

export default AddQuestionnaireSystem
